import styled from 'styled-components';

// 모달 Bg
export const ModalBg = styled.div`
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
`;

// 모달 타입 1
// width: 984px
export const ModalType1 = styled.div`
  width: 100%;
  max-width: 984px;
  min-width: 984px;
  background-color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 4px 4px 20px 0 rgba(58, 58, 58, 0.44);
  .title-box {
    width: 100%;
    height: 58px;
    background: #f2f9fc;
    box-sizing: border-box;
    padding: 0 28px;
    > h1 {
      font-weight: 500;
      font-size: 20px;
      color: #333;
    }
    > .x-btn {
      width: 16px;
    }
  }
  .cnt-wrap {
    box-sizing: border-box;
    padding: 32px 28px;
    background: #fff;
    > h3 {
      text-align: right;
      font-size: 16px;
      color: #444;
      > span {
        color: ${(props) => props.theme.subColor1};
      }
    }
    .table-wrap {
      margin-top: 12px;
      table tr {
        > th {
          .star-point {
            display: inline-block;
            color: ${(props) => props.theme.subColor1};
          }
        }
        > td {
          &.address {
            .address-1 {
              width: 370px;
            }
            .address-2 {
              width: 468px;
              margin-top: 8px;
            }
          }
          input {
            width: 180px;
          }
          .confirm-btn-box {
            gap: 8px;
          }
        }
      }
    }
    .btn-wrap {
      display: flex;
      justify-content: center;
      gap: 8px;
      margin-top: 32px;
    }
  }
`;

// 모달 타입 2
// width: 400px
export const ModalType2 = styled.div`
  width: 100%;
  max-width: 400px;
  background-color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 4px 4px 20px 0 rgba(58, 58, 58, 0.44);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 40px 20px;
  > .img-box {
    width: 64px;
  }
  > p {
    text-align: center;
    margin-top: 16px;
    font-size: 18px;
    font-weight: 500;
    color: #333;
  }
  > .btn-box {
    margin-top: 48px;
    display: flex;
    justify-content: center;
    gap: 8px;
  }
`;

// 검색 옵션 박스
export const SearchOptionBox = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  border-radius: 12px;
  background-color: #f9f9f9;
  display: flex;
  justify-content: space-between;
  gap: 20px;
`;

// 테이블 옵션 박스
export const TableOpitonBox = styled.div`
  margin-top: 40px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  > h1 {
    font-size: 16px;
    font-weight: 500;
    color: #222;
    > span {
      font-weight: 700;
      display: inline-block;
    }
  }
  > .right-box {
    display: flex;
    gap: 8px;
  }
`;

// 테이블 타입1
export const TableType1 = styled.div`
  overflow: auto;
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: #aaa;
    border-radius: 999px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  tr {
    th {
      height: 50px;
      font-size: 15px;
      font-weight: 500;
      color: #222;
      background: #f9f9f9;
      box-sizing: border-box;
      padding: 0 12px;
      white-space: nowrap;
      border: 1px solid #e6e6e6;
      text-align: center;
      border-top: 2px solid #222222;
      &:first-child {
        border-left: none;
      }
      &:last-child {
        border-right: none;
      }
    }
    td {
      height: 50px;
      font-size: 15px;
      font-weight: 400;
      color: #666;
      background: #fff;
      box-sizing: border-box;
      padding: 0 12px;
      white-space: nowrap;
      border: 1px solid #e6e6e6;
      text-align: center;
      &.button-text {
        color: ${(props) => props.theme.mainColor1};
        text-decoration: underline;
        cursor: pointer;
      }
      &:first-child {
        border-left: none;
      }
      &:last-child {
        border-right: none;
      }
      > a {
        color: #215cf4;
        font-weight: 500;
      }
    }
  }
  @media (max-width: 1420px) {
    tr {
      th {
        height: 42px;
        font-size: 14px;
        padding: 0 8px;
      }
      td {
        height: 42px;
        font-size: 14px;
        padding: 0 8px;
      }
    }
  }
`;
export const TableType1_2 = styled(TableType1)`
  tr {
    th {
      border-top: none;
      border-left: none;
      border-right: none;
      text-align: left;
      width: 140px;
      min-width: 140px;
      max-width: 140px;
    }
    td {
      border-left: none;
      border-right: none;
      text-align: left;
      padding: 8px;
    }
    &:first-child > * {
      border-top: 2px solid #222222;
    }
  }
`;
export const TableType1Mini = styled(TableType1)`
  tr {
    th {
      height: 36px;
      font-size: 13px;
      padding: 0 8px;
    }

    td {
      height: 36px;
      font-size: 13px;
      padding: 0 8px;
    }
  }
`;

// 테이블 타입2
export const TableType2 = styled.div`
  overflow: auto;
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: transparent;
  }
  &::-webkit-scrollbar-track {
    background: #aaa;
    border-radius: 999px;
  }
  tr {
    th {
      height: 43px;
      font-size: 16px;
      font-weight: 500;
      color: #4f4f4f;
      background: #f9fbfc;
      box-sizing: border-box;
      padding: 0 16px;
      white-space: nowrap;
      border: 1px solid #f3f3f3;
      text-align: left;
    }
    td {
      height: 43px;
      font-size: 16px;
      font-weight: 500;
      color: #4f4f4f;
      background: #fff;
      box-sizing: border-box;
      padding: 0 16px;
      white-space: nowrap;
      border: 1px solid #f3f3f3;
      text-align: left;
    }
  }
`;

// 페이지네이션
export const Pagenation = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;

  > button {
    width: 14px;
    &:disabled {
      opacity: 0;
      cursor: inherit;
    }
  }

  > ul {
    display: flex;
    gap: 4px;

    > li {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      color: #555;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      &.active {
        background: ${(props) => props.theme.mainColor1};
        color: #fff;
        font-weight: 500;
      }
    }
  }
`;

// 컨텐츠 박스 타입1
const CntBoxType1 = styled.div`
  box-sizing: border-box;
  padding: 24px 20px 20px 20px;
  border-radius: 12px;
  background: #fff;
  @media (max-width: 1420px) {
    padding: 20px 16px 16px 16px;
  }
`;

// 탭메뉴 타입1
export const TabMenuType1 = styled.div`
  display: flex;
  gap: 8px;
  > button {
    box-sizing: border-box;
    padding: 8px 16px;
    border-radius: 4px;
    font-size: 16px;
    color: #666;
    font-weight: 500;
    background: #fff;
    border: 1px solid #dedede;
    &.active {
      color: #fff;
      background: ${(props) => props.theme.mainColor2};
      border: 1px solid #dedede;
    }
  }
  @media (max-width: 1420px) {
    gap: 6px;
    > button {
      padding: 6px 12px;
      font-size: 14px;
    }
  }
`;
// 탭메뉴 타입1 미니
export const TabMenuType1Mini = styled(TabMenuType1)`
  gap: 6px;
  > button {
    padding: 6px 12px;
    font-size: 14px;
  }
`;

// 리스트 타입1
export const ListType1 = styled.ul`
  display: flex;
  flex-wrap: wrap;
  margin-top: 6px;
  gap: 4px;
  > li {
    background-color: ${(props) => props.theme.mainColor1};
    border-radius: 999px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding: 4px 10px;
    gap: 8px;
    > .text {
      color: #fff;
      font-size: 12px;
    }
    > button {
      width: 10px;
    }
  }
`;

ListType1;

const CS = {
  ModalBg,
  ModalType1,
  ModalType2,
  SearchOptionBox,
  TableOpitonBox,
  TableType1,
  TableType1_2,
  TableType1Mini,
  TableType2,
  Pagenation,
  CntBoxType1,
  TabMenuType1,
  TabMenuType1Mini,
  ListType1,
};

export default CS;
